<template>
    <mt-header :title="title">
        <router-link to="/" slot="left" v-if="back">
            <mt-button icon="back" @click="goBack()" v-if="showBack"></mt-button>
        </router-link>
        <router-link to="/user" slot="left" v-else>
            <van-icon name="user-o" style="font-size:20px;"/>
        </router-link>
    </mt-header>
</template>

<script type="text/ecmascript-6">
    import { Header } from 'mint-ui';

    export default{
        name:'Header',
        data(){
            return {
                filtrationPopup:{
                    show:false,
                    showBack:false,
                }
            }
        },
        props:{
            title:{
                required:true
            },
            back:{
                required:true
            },
//            url:{
//                default:'/'
//            }
        },
        mounted(){
            this.checkLogin()
            this.checkBrowser()
        },
        methods:{
            checkBrowser(){
                var userAgent = navigator.userAgent.toLowerCase();
                if(userAgent.indexOf('applewebkit') > -1 && userAgent.indexOf('mobile') > -1 && userAgent.indexOf('safari') > -1
                        && userAgent.indexOf('linux') == -1 && userAgent.indexOf('android') == -1){
                    this.showBack = false
                }else{
                    this.showBack = true
                }
            },
            checkLogin(){
                let info = this.$cookies.get('LOGIN_INFO')
                if(!info){
                    this.logout()
                }
                this.name = info && info.xm ? info.xm : ''
            },
            logout(){
                this.$cookies.remove('LOGIN_INFO')
                this.$router.push({ name: 'login'})
            },
            goBack(){
                window.history.go(-1);return false;
                //this.$router.push(this.url)
                //this.$router.go(-1);
                //this.$router.back()
                //this.$emit('listenCloseEvent')
            }
        }
    }
</script>
<style scoped>
    .m-header{
        width:100%;
        height:50px;
        position: fixed;
        top:0;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile/components/Header.vue